import { render } from "./NotificationAutomations.vue?vue&type=template&id=df61d57e&scoped=true"
import script from "./NotificationAutomations.vue?vue&type=script&lang=js"
export * from "./NotificationAutomations.vue?vue&type=script&lang=js"

import "./NotificationAutomations.vue?vue&type=style&index=0&id=df61d57e&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df61d57e"]])

export default __exports__